import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.214 19.071a.786.786 0 1 0 0 1.572.786.786 0 0 0 0-1.572M14.357 19.071a.786.786 0 1 0 0 1.572.786.786 0 0 0 0-1.572M15.929 19.071a.786.786 0 1 0 0-1.572.786.786 0 0 0 0 1.572M15.929 15.929a.786.786 0 1 0 0-1.572.786.786 0 0 0 0 1.572M14.357 17.5a.785.785 0 1 0-1.57 0 .785.785 0 0 0 1.57 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.857 15.567a7.86 7.86 0 0 0-3.143-5.924v-5.5a.786.786 0 0 0-1.571 0v4.55a7.8 7.8 0 0 0-2.357-.622V1.786a.786.786 0 0 0-1.572 0V8.07a7.8 7.8 0 0 0-2.357.637V4.143a.786.786 0 1 0-1.571 0v5.5a7.86 7.86 0 0 0-3.08 5.9C1.574 16.542 1 17.784 1 18.68 1 21.515 6.5 23 12 23s11-1.485 11-4.321c0-.888-.566-2.13-3.143-3.112M2.571 18.71c0-.385.55-.95 1.737-1.47A7.86 7.86 0 0 0 5.8 20.715c-2.059-.605-3.23-1.399-3.23-2.035zm6.027 2.538s-.047-.055-.087-.079a6.286 6.286 0 1 1 6.985 0s0 .047-.055.063A27 27 0 0 1 12 21.43a26 26 0 0 1-3.402-.213zm9.688-.605a7.86 7.86 0 0 0 1.477-3.442c1.123.543 1.666 1.085 1.666 1.478 0 .628-1.155 1.414-3.143 1.964"
    }, null, -1)
  ]))]))
}
export default { render: render }